import { InquiryRevisionListElement } from 'modules/InquiryDetails/InquiryRevision/InquiryRevision.model';

export interface RevisionState {
  revisionList: InquiryRevisionListElement[];
  selectedRevisionId: string;
}

export const getNextRevisionIdSelector = (state: RevisionState) => {
  const currentSelectionIndex = state.revisionList.findIndex(
    (rev) => rev.id === state.selectedRevisionId,
  );
  return state.revisionList[currentSelectionIndex - 1].id;
};

export const getPreviousRevisionIdSelector = (state: RevisionState) => {
  const currentSelectionIndex = state.revisionList.findIndex(
    (rev) => rev.id === state.selectedRevisionId,
  );
  return state.revisionList[currentSelectionIndex + 1].id;
};
